import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { customerService } from "../../services/customerService";

export const fetchCustomers = createAsyncThunk(
  "customers/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await customerService.list(params);
      return res.data.data; // { content, totalElements, totalPages, number }
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Müşteriler yüklenemedi");
    }
  }
);

export const createCustomer = createAsyncThunk(
  "customers/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await customerService.create(payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Müşteri eklenemedi");
    }
  }
);

export const updateCustomer = createAsyncThunk(
  "customers/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await customerService.update(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Müşteri güncellenemedi");
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "customers/delete",
  async (id, { rejectWithValue }) => {
    try {
      await customerService.remove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Müşteri silinemedi");
    }
  }
);

export const hardDeleteCustomer = createAsyncThunk(
  "customers/hardDelete",
  async (id, { rejectWithValue }) => {
    try {
      await customerService.hardRemove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Müşteri kalıcı silinemedi");
    }
  }
);

export const setCustomerActive = createAsyncThunk(
  "customers/setActive",
  async ({ id, active }, { rejectWithValue }) => {
    try {
      const res = await customerService.setActive(id, active);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Durum değiştirilemedi");
    }
  }
);

const upsert = (state, updated) => {
  const i = state.items.findIndex((s) => s.id === updated.id);
  if (i !== -1) state.items[i] = { ...state.items[i], ...updated };
};

const customerSlice = createSlice({
  name: "customers",
  initialState: {
    items: [],
    totalElements: 0,
    totalPages: 0,
    page: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearCustomerError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const p = action.payload;
        state.isLoading = false;
        state.items = p.content ?? [];
        state.totalElements = p.totalElements ?? 0;
        state.totalPages = p.totalPages ?? 0;
        state.page = p.number ?? 0;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(setCustomerActive.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        const i = state.items.findIndex((s) => s.id === action.payload);
        if (i !== -1) state.items[i] = { ...state.items[i], active: false };
      })
      .addCase(hardDeleteCustomer.fulfilled, (state, action) => {
        state.items = state.items.filter((s) => s.id !== action.payload);
      });
  },
});

export const { clearCustomerError } = customerSlice.actions;
export default customerSlice.reducer;
